import axios from "axios";
import { getURl, getHeaders } from "./core";
import { Util } from "../common/util";

const util = new Util();
const url = `${getURl()}/auth/v1`;

export function logout() {
  return axios({
    url: `${url}/logout`,
    data: {},
    headers: getHeaders(),
  });
}

export function signin(privateURL, userName, password) {
  return axios({
    method: "POST",
    url: `${url}/login`,
    headers: {
      "Content-Type": "application/json",
      privateURL: privateURL,
      userName: userName,
      password: password,
    },
    data: {},
  });
}

export function signinByMicrosoft(userName, name) {
  return axios({
    method: "POST",
    url: `${url}/microsoft_login`,
    headers: {
      "Content-Type": "application/json",
      userName,
      name
    },
    data: {},
  });
}

export function changePassword(id, password, currentPassword) {
  return axios({
    method: "PUT",
    url: `${getURl()}/user/v1/reset/password`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${util.getAccessToken()}`,
      id: id,
      currentPassword: currentPassword,
      password: password,
    },
    data: {},
  });
}
